<template>
  <div class="OrderManageDetail-root">
    <div v-if="orderDetail.status === statusEnu.draft && reason" class="abnormal">
      <div class="err-image">
        <a-icon class="err_icon" type="info-circle" theme="filled" />
        <div>
          <h4>推送到仓库系统失败!</h4>
         <p>wms报错 [{{reason}}]</p>
         <p v-if="!orderDetail.ext || !orderDetail.ext.demoData">
          <a-button  
            v-if="showEditButton(orderDetail.status, orderDetail.odrChannel, orderDetail) && !orderDetail.ifRefuseWaybill"
            v-auth="$_ButtonPermission.WAREHOUSE_EDIT" 
            type="link" 
             @click="abnormalEdit()">编辑订单</a-button>
          <a-button type="link" @click="afreshPush()">重新推单</a-button>
          <a-tooltip>
            <template slot="title">wms推单失败后，重新向WMS提交订单快捷操作</template>
          <a-icon type="exclamation-circle" class="tipIcon" />
          </a-tooltip>
         </p>
        </div>
      </div>
     
      
    </div>
    
    <a-tabs type="card" :default-active-key="defaultTab" class="tabs-card" @change="tabChange">
      <a-tab-pane :key="DetailTabs.BASEINFO" tab="基本信息">
        <div class="tatBox">
          <div class="warehouse-type">{{warehouseType}}</div>
        </div>
        <base-info ref="baseInfo" :sensitive-fields="sensitiveFields" :order-detail="orderDetail" @change="getDetail"></base-info>
      </a-tab-pane>
      <a-tab-pane :key="DetailTabs.WAREHOUSE" tab="仓库作业信息" force-render>
        <warehouse-operation ref="warehouse" :is-now-wa-customer="isNowWaCustomer" :order-detail="orderDetail"></warehouse-operation>
      </a-tab-pane>
      <a-tab-pane v-if="showCar" :key="DetailTabs.CARINFO" tab="派车信息" force-render>
        <car-info ref="carInfo" :order-detail="orderDetail"></car-info>
      </a-tab-pane>
    </a-tabs>
    <fix-bottom class="fotter_btn">
      <template slot="button">
          <a-button @click="closeOrder">
          返回
          </a-button>
          <div v-if="!orderDetail.ext || !orderDetail.ext.demoData">
            <a-button
            v-if="showEditButton(orderDetail.status, orderDetail.odrChannel, orderDetail) && !orderDetail.ifRefuseWaybill"
            v-auth="$_ButtonPermission.WAREHOUSE_EDIT"
             type="primary" 
             @click="abnormalEdit()"
             >编辑订单</a-button>
            <a-button v-if="orderDetail.status === statusEnu.draft && reason" type="primary" @click="afreshPush()">重新推单</a-button>
          </div>
      </template>
    </fix-bottom>
  </div>
</template>

<script>
import FixBottom from '@/components/fix-bottom/index.vue';
import { ruleCropSensitive } from '@/api/orderRules'
import { EventBus } from '@/utils/event-bus'
import BaseInfo from './BaseInfo.vue'
import CarInfo from './CarInfo'
import WarehouseOperation from './WarehouseOperation'
import {DetailTabs, SCENETYPE, ORDERSTATUS as statusEnu,SCENE} from '../warehouseList/constant'
import {featchOrderDetail,afreshAccept} from '../api.js'
import {getConfig} from '../../orderManage/api'

const showStatus = ['DRAFT', 'SUBMITTED', 'EXP_CAL_STATUS', 'PRE_DRAFT']
const openApi = 14

export default {
  name: 'OrderManageDetail',
  components: {
    BaseInfo,
    CarInfo,
    WarehouseOperation,
    FixBottom,
  },
  data () {
    return {
      bottom: 0,
      DetailTabs,
      defaultTab: this.$route.query.detailTab || DetailTabs.BASEINFO,
      warehouseType: '',
      orderDetail: {},
      showCar: false,
      sensitiveFields: [],
      statusEnu,
      isDischarge:false, // 一装多卸
      isNowWaCustomer:false, // nowwa咖啡白名单
    }
  },
  computed: {
    reason() {
      return this.orderDetail?.exceptionReason?.reason || '';
    },
  },
  created () {
    this.getDetail();
    this.getWarehouseMultiDischarge()
    this.getConfigList()
  },
  mounted () {},
  beforeDestroy() {
    EventBus.$emit('orderTypeHidde')
  },
  methods: {
    async getSensitiveRule(){
      const customerReqs = [
        {
          customerCode: this.orderDetail.tenantId,
          carrierTenantId: this.orderDetail.carrierTenantId,
        }
      ]
      const res = await ruleCropSensitive({customerReqs})
      this.sensitiveFields = res.result?.orderSensitiveFields || []
    },
    async getConfigList(){
        const res=await getConfig({
            appId: "1002",
            keys:['oms.nowwa.white.list']
        })
        const customerCode = this.$store.state.user?.customerCode
        const whiteList=res.configs[0]?.value?.split(',')||[];
        this.isNowWaCustomer = whiteList.includes(customerCode)
    },
    async getWarehouseMultiDischarge(){
      const res = await getConfig({
        appId: "1004",
        keys:['oms.warehouse.multi.discharge']
      })
      const customerCode = this.$store.state.user?.customerCode
      this.isDischarge = res.configs[0]?.value?.split(',').includes(customerCode)
    },
    abnormalEdit(){
      if(!this.isDischarge&&this.orderDetail.isWarehouseMultiDischargeOrder){
         // 如果当前订单是一装多卸订单,但是当前客户没有在一装多卸白名单之类
        this.$message.warning('操作仓配一装多卸订单需开通权限，请联系管理员处理')
        return
      }
     const {warehouseContract} = this.$route.query
      if(!warehouseContract){
        this.$message.warning('没有仓合同！')
        return  
      }
      this.$router.push({
          // path: `/order/warehous-edit-single`,
          path: `/order/editOrder`,
          query: {
            odrNo: this.$route.query.unifyOdrNo,
            productCode: 'warehouse',
            customerCode:this.orderDetail.tenantId,
          },
        })
    },
   async afreshPush(){
      try {
        await afreshAccept({unifyOdrNos: [this.$route.query.unifyOdrNo]})
        this.$message.success('推单成功')
        this.$router.go(0)
      } catch (error) {
       const res= await featchOrderDetail({unifyOdrNo: this.$route.query.unifyOdrNo})
        this.orderDetail.exceptionReason.reason=res?.exceptionReason?.reason||''
      }
    },
    async getDetail() {
      this.orderDetail = await featchOrderDetail({
        unifyOdrNo: this.$route.query.unifyOdrNo
      })
      this.getSensitiveRule();
      if (this.orderDetail.needTransport) {
        this.showCar = true
      }
      this.warehouseType = SCENETYPE[this.orderDetail.scene]
    },
    tabChange(){
      // if(val === 'car'){
      //   this.$refs.carInfo.featchData()
      // }else{
      //   this.$refs.baseInfo.getOrderDetail()
      // }
    },
    callback(){},
    closeOrder() {
        this.$router.go(-1);
    },
     showEditButton(status, odrChannel, row) {
       if(status){
         return (showStatus.includes(status.toString()) && openApi !== odrChannel) || (openApi === odrChannel && status === 'PRE_DRAFT' && row.scene !== SCENE.DELIVER_STORE && row.scene !== SCENE.DELIVER_TRANSPORT_STORE)
       }
      return false

    },
  }
}
</script>

<style lang="less" scoped>
.OrderManageDetail-root {
  padding-bottom: 50px;
  .err-image {
    display: inline-flex;
    background: #FFEFDE;
    border-radius: 6px;
    padding: 11px 38px 11px 28px;
    color: #FB9432;
    margin-bottom: 16px;
    margin-right: 20px;
    h4{
      color: #606266;
      font-size: 16px;
    }
    .err_icon {
      font-size: 24px;
      margin-right: 20px;
    }
    p{
      line-height: 30px;
    }
    button{
      padding: 0;
      margin-right: 20px;
    }
  }
  .abnormal {
    button:active {
      background-color: #EBEDF0;
    }
    .tipIcon {
      color: #ccc;
    }
  }
  
  .tatBox{
    position: absolute;
    width: 120px;
    height: 120px;
    top: 47px;
    right: 0;
    overflow: hidden;
  }
  .warehouse-type {
    position: absolute;
    width: 120px;
    background: #06B880;
    text-align: center;
    color: #fff;
    top: 20px;
    right: -27px;
    height: 27px;
    line-height: 27px;
    transform: rotate(45deg);
  }
  /deep/ .ant-descriptions-item-content {
    // width: calc(100% - 100px);
    word-break: break-all;
  }
  /deep/ .descriptions-info {

    .ant-descriptions-row {
      .ant-descriptions-item-content {
        width: auto;
      }
    }
  }
  .fotter_btn {
    button {
      margin-right: 20px;
    }
  } 
}
.affixStyle{
    // width: 100% !important;
    position: fixed;
}
.align-right {
    width: 100%;
    // margin-left: -30px;
    text-align: right; 
    height: 50px;
    // background-color: #f0f2f5;
    background-color: #ffffff;
    box-shadow: 0px -5px 5px -5px rgba(0, 0, 0, 0.2);
    padding-top: 10px;
    box-sizing: border-box;
    padding-right: 30px;
    box-sizing: border-box;
    .close{
        margin-right: 30px;
    }
}
/deep/ .ant-table-column-title{
    font-weight: bold;
}
 /deep/ .ant-descriptions-item-label{
    width: 150px !important;
    text-align: right;
  }
</style>

<style lang="less">
.OrderManageDetail-root {
  .ant-descriptions {
    .ant-descriptions-row {
      .ant-descriptions-item-label, .ant-descriptions-item-content {
        padding: 11px 16px;
      }
      .ant-descriptions-item-label {
        color: #606266;
      }
      .ant-descriptions-item-content {
        color: #171717;
      }
    }
  }
}
</style>